import Accordion from 'react-light-accordion';
import OperationalDashboardAccordionsByDiscipline from './operationalDashboardAccordionsByDiscipline';
import { useCallback, useEffect } from 'react';
import * as Shared from "../../../common/shared";
import MessageEmptyData from '../../../common/messageEmptyData';

const OperationalDashboardBody = ({dashboardData}) => {
    const isDisciplineEmpty = useCallback((disciplineData) =>
        Object
            .keys(disciplineData.summary)
            .every(key => disciplineData.summary[key] === null) && disciplineData.summary_by_rigs.length === 0, []);

    useEffect(() => {
        Shared.toggleAllAccordionItems();
    }, [dashboardData]);

    if (dashboardData === null) {
        return null;
    }

    if (Object.keys(dashboardData).map(key => dashboardData[key]).every(discipline => isDisciplineEmpty(discipline))) {
        return <MessageEmptyData />;
    }

    return (
        <div className="card" id="accordion_card">
            <div className="card-body">
                <div className="default-according panel-accordion" id="accordionclose">
                    <Accordion atomic="false">
                        {
                            Object.keys(dashboardData).map(key => (
                                <OperationalDashboardAccordionsByDiscipline
                                    key={key}
                                    disciplineKey={key}
                                    disciplineData={dashboardData[key]}
                                />
                            ))
                        }
                    </Accordion>
                </div>
            </div>
        </div>
    );
}

export default OperationalDashboardBody;